import React from 'react'
import { Routes, Route } from 'react-router-dom'
import ToolsHome from './ToolsHome'
import ConstitutionIdentification from './ConstitutionIdentification'
import MedicineRecognition from './MedicineRecognition'
import IntelligentDiagnosis from './IntelligentDiagnosis'

const Tools: React.FC = () => {
  return (
    <Routes>
      <Route index element={<ToolsHome />} />
      <Route path="constitution" element={<ConstitutionIdentification />} />
      <Route path="medicine" element={<MedicineRecognition />} />
      <Route path="diagnosis" element={<IntelligentDiagnosis />} />
    </Routes>
  )
}

export default Tools

